<!--
* An image box component
*
* @param {string} image - image source url
* @param {string} caption - image caption
*
-->

<template>

  <div class="app_image_box">
    <!-- photo box -->
    <div class="app_image_box__image_wrapper"
         v-if="image">
      <img class="app_image_box__image"
           v-bind:src="image" />
    </div>

    <!-- caption and checkbox -->
    <div class="app_image_box__footer"
         v-bind:class="{ app_image_box__footer_border: !image }">
      <!-- Caption -->
      <div
        class="form__image_caption">{{caption}}</div>
    </div>
  </div>

</template>

<script>
  export default {
    props: {
      caption: {
        type: String
      },

      image: {
        type: String
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/sass/shared.scss";

  // keep the highlighted border if view is selected
  .app_image_box.selected {
    .app_image_box__image_wrapper {
      border: $secondary-border-style;
      border-bottom: 0;
    }
    .app_image_box__footer {
      border: $secondary-border-style;
      border-top: $default-border-style;
    }
    .app_image_box__footer_border {
      border-top: $secondary-border-style;
    }
  }

  .app_image_box__image_wrapper {
    display: flex;
    width: 100%;
    background: $quaternary-brand-color;
    border: $default-border-style;
    border-bottom: 0;
    font-size: $medium-font-size;
  }


  .app_image_box__image {
    display: block;
    margin-left: auto;
    margin-right: auto;
    user-select: none;
    height: $dims-image-checkbox-height;
  }

  .app_image_box__footer {
    pointer-events: none;
    display: flex;
    width: 100%;
    background: $secondary-brand-color;
    padding: $dims-spacing-small;
    border: $default-border-style;
    font-size: $medium-font-size;
  }

  .form__image_caption {
    display: block;
    width: 100%;
    padding-left: $dims-spacing-small;
    font-size: $medium-font-size;
  }
</style>
